export type LotusAdminPageConfig = {
  id: string
  path: string
  title: string
  rootId: string
}

/** Lotus sidebar pages — blank shells; feature content wired later */
export const LOTUS_ADMIN_PAGES: LotusAdminPageConfig[] = [
  { id: 'member-listing', path: 'member-listing', title: 'Member Listing', rootId: 'agency-management' },
  {
    id: 'position-taking-listing',
    path: 'position-taking-listing',
    title: 'Position Taking Listing',
    rootId: 'agency-management',
  },
  { id: 'transfer-agency', path: 'transfer', title: 'Transfer', rootId: 'agency-management' },
  { id: 'net-exposure', path: 'net-exposure', title: 'Net Exposure', rootId: 'risk-management' },
  { id: 'bet-ticker', path: 'bet-ticker', title: 'Bet Ticker', rootId: 'risk-management' },
  {
    id: 'event-management',
    path: 'lotus-event-management',
    title: 'Event Management',
    rootId: 'risk-management',
  },
  { id: 'pl-report-market', path: 'pl-report-market', title: 'P&L Report by Market', rootId: 'reports' },
  { id: 'pl-report-agent', path: 'pl-report-agent', title: 'P&L Report by Agent', rootId: 'reports' },
  { id: 'casino-report', path: 'casino-report', title: 'Casino Report', rootId: 'reports' },
  { id: 'bet-list', path: 'bet-list', title: 'Bet List', rootId: 'reports' },
  { id: 'transfer-statement', path: 'transfer-statement', title: 'Transfer Statement', rootId: 'reports' },
  { id: 'balance', path: 'balance', title: 'Balance', rootId: 'account' },
  { id: 'statement', path: 'statement', title: 'Statement', rootId: 'account' },
  { id: 'user-listing', path: 'user-listing', title: 'User Listing', rootId: 'admin-users' },
  {
    id: 'notifications',
    path: 'broadcast-notifications',
    title: 'Notifications',
    rootId: 'additional-management',
  },
  {
    id: 'undeclared-bets',
    path: 'undeclared-bets',
    title: 'Undeclared Bets',
    rootId: 'additional-management',
  },
  {
    id: 'market-analysis',
    path: 'market-analysis',
    title: 'Market Analysis',
    rootId: 'additional-management',
  },
]

export const LOTUS_ADMIN_ROUTE_SEGMENTS = new Set(LOTUS_ADMIN_PAGES.map((p) => p.path))

export const LOTUS_ADMIN_DEFAULT_ROUTE = 'balance'

export function findLotusPageByPath(pathSegment: string): LotusAdminPageConfig | undefined {
  const segment = pathSegment.replace(/^\/admin\/?/, '').split('?')[0]
  return LOTUS_ADMIN_PAGES.find((p) => p.path === segment)
}

export function findLotusPageById(id: string): LotusAdminPageConfig | undefined {
  return LOTUS_ADMIN_PAGES.find((p) => p.id === id)
}
